const getUserTable = (state) => {
    return state.user_table
}

export {
    getUserTable,
};